/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import React, { useContext, useRef, useState } from 'react';
import PhoneInput, { formatPhoneNumberIntl } from "react-phone-number-input";
import axios from 'axios';
import Usericon from '../../Icon/user.svg';
import Emailicon from '../../Icon/email.svg';
import Callicon from '../../Icon/call.svg';
import Lockicon from '../../Icon/lock.svg';
import Eyeicon from '../../Icon/eye.svg';
import Eyeslashicon from '../../Icon/eye-slash.svg';
import { LuUsers } from "react-icons/lu";
import { MyContext } from '../../Context/MyProvider';
import { showTost } from '../../showTost';
import { db, RecvestToken, requestForToken } from '../../firebase/firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import secureLocalStorage from 'react-secure-storage';
const Signup = () => {

  const { t } = useTranslation();
  const { setIsLoginShow, setIsSignUpShow, BaseUrl, setIsLogin } = useContext(MyContext);

  const [value, setValue] = useState();
  const [passType, setPassType] = useState("Password");
  const [signUpData, setSignUpData] = useState({
    name: "",
    email: "",
    password: "",
    referral: ""
  });
  const [isOtpShow, setIsOtpShow] = useState(false);
  const [otpFiled, setOtpFiled] = useState(Array(6).fill(''));
  const [sendOtp, setSendOtp] = useState("");

  const InputRef = useRef();
  const OtpRef = useRef(Array.from({ length: 6 }, () => null));
  const navoigate = useNavigate();

  const handelCheck = () => {
    const emailValidation = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

    if (!signUpData.name || !signUpData.email || !value || !signUpData.password) {
      showTost(t("Please Enter Details !!"), "error");
      return;
    }

    if (!emailValidation.test(signUpData.email)) {
      showTost(t("Please Enter a Valid Email !!"), "error");
      return;
    }

    if (signUpData.password.length < 3) {
      showTost(t("Password must be at least 3 characters long !!"), "error");
      return;
    }

    const formattedNumber = formatPhoneNumberIntl(value);
    const countryCode = formattedNumber.split(' ')[0];
    const numberWithoutCode = formattedNumber.replace(countryCode, '').trim();
    const cleanedNumber = numberWithoutCode.split(' ').join('');

    const Data = {
      mobile: cleanedNumber,
      ccode: countryCode,
    };

    axios.post(`${BaseUrl}user_api/mobile_check.php`, Data)
      .then((res) => {
        console.log("mobile_check.php", res);
        const { ResponseCode, ResponseMsg } = res.data;
        if (ResponseCode === "200") {
          axios.post(`${BaseUrl}user_api/email_check.php`, { email: signUpData.email })
            .then((res) => {
              const { ResponseCode, ResponseMsg } = res.data;
              if (ResponseCode === "200") {
                axios.get(`${BaseUrl}user_api/sms_type.php`)
                  .then((res) => {
                    // console.log("sms_type", res);
                    const { ResponseCode, SMS_TYPE, otp_auth } = res.data;
                    if (ResponseCode === "200") {
                      if (otp_auth === "Yes") {
                        if (SMS_TYPE === "Msg91") {
                          handleMSG91(Data);
                        } else if (SMS_TYPE === "Twilio") {
                          handleTwilio(Data);
                        }
                      } else {
                        handleSignUp();
                      }
                    }
                  });
              } else {
                showTost(ResponseMsg, "error");
              }
            })
            .catch((error) => {
              console.error(error);
            })
        } else {
          showTost(ResponseMsg, "error");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleMSG91 = (data) => {
    axios.post(`${BaseUrl}user_api/msg_otp.php`, data)
      .then((res) => {
        // console.log("msg91", res);
        const { ResponseCode, otp } = res.data;
        if (ResponseCode === "200") {
          showTost(t("OTP send successfully !!"), "success");
          setIsOtpShow(true);
          setSendOtp(otp);
        }
      });
  };

  const handleTwilio = (data) => {
    axios.post(`${BaseUrl}user_api/twilio_otp.php`, data)
      .then((res) => {
        // console.log("twilio", res);
        const { ResponseCode, otp } = res.data;
        if (ResponseCode === "200") {
          showTost(t("OTP send successfully !!"), "success");
          setIsOtpShow(true);
          setSendOtp(otp);
        }
      });
  };

  const handleChange = (index, value) => {
    const Otp = [...otpFiled];
    Otp[index] = value;
    setOtpFiled(Otp);
    if (value && !isNaN(value) && index < OtpRef.current.length - 1) {
      OtpRef.current[index + 1].focus();
    }
  };

  const InputHandle = (index, e) => {
    if (e.key === "Backspace" && index > 0 && !e.target.value) {
      OtpRef.current[index - 1].focus();
    }
  };

  const HandelVerifyOtp = () => {
    if (sendOtp === Number(otpFiled.join(""))) {
      handleSignUp();
    } else {
      showTost("OTP is invalid !!", "error");
    }
  };

  const handleSignUp = () => {
    const formattedNumber = formatPhoneNumberIntl(value);
    const countryCode = formattedNumber.split(' ')[0];
    const numberWithoutCode = formattedNumber.replace(countryCode, '').trim();
    const cleanedNumber = numberWithoutCode.split(' ').join('');

    const Data = {
      name: signUpData.name,
      email: signUpData.email,
      mobile: cleanedNumber,
      ccode: countryCode,
      password: signUpData.password,
      refercode: signUpData.referral ? signUpData.referral : ""
    };

    axios.post(`${BaseUrl}user_api/u_reg_user.php`, Data)
      .then((res) => {
        // console.log("u_reg_user", res);

        const { ResponseMsg, ResponseCode, UserLogin } = res.data;

        const toastType = ResponseCode === '200' ? 'success' : 'error';
        showTost(ResponseMsg, toastType);

        if (ResponseCode === "200") {
          secureLocalStorage.setItem("LoginData", JSON.stringify(UserLogin));
          HandleFirebase(UserLogin);
          navoigate("/");
          secureLocalStorage.setItem("Userid", UserLogin.id);
          setIsLogin("123");
          setIsSignUpShow(false);
        }

      })
      .catch((error) => {
        console.error(error);
      });
  };

  const HandleFirebase = async (Data) => {

    const token = await requestForToken();

    const userRef = doc(db, "MagicUser", Data.id);
    getDoc(userRef)
      .then((docSnapshot) => {
        if (!docSnapshot.exists() && token) {
          // console.log("Not Exists");

          const number = Data?.ccode + Data?.mobile;

          setDoc(userRef, {
            email: Data?.email,
            isOnline: false,
            lastActive: new Date(),
            name: Data?.name,
            number,
            pro_pic: Data?.pro_pic,
            token: token,
            uid: Data?.id
          })
            .then(() => {
              // console.log('User Add in Firebase..!!');
            });
        }
      });
  };

  return (
    <div className='signup-box'>
      {isOtpShow
        ? <div className="py-[10px] px-[20px]">
          <h1 className='text-center text-[24px] font-[600]'>{t("Almost there!")}</h1>
          <p className='text-center text-gray-500 text-[18px] leading-[25px]'>{t("You need to enter 6-digit code that we have send to your mobile number")} <span className='text-black text-[16px] font-[500]'>{value}</span></p>
          <h1 className='text-center'>{t("Your OTP")} : {sendOtp && sendOtp}</h1>
          <div className="flex items-center gap-[20px] mt-[10px]">
            {otpFiled.map((value, index) => {
              return <input type="number"
                ref={(e) => (OtpRef.current[index] = e)}
                key={index}
                value={value}
                className='otp-box focus-within:outline-[#0000ffb7]'
                maxLength="1"
                onChange={(e) => handleChange(index, e.target.value)}
                onKeyDown={(e) => InputHandle(index, e)}
              />
            })}
          </div>
          <button onClick={HandelVerifyOtp} className='button'>{t("VERIFY OTP")}</button>
        </div>
        : <div className="py-[10px] px-[20px]">
          <h1 className="text-[24px] font-[600]">{t("Sign Up")}</h1>
          <div className="login-input focus-within:border-[#0000ffb7] mt-[20px] focus-within:border-[1px]">
            <img src={Usericon} alt="userIcon" className="w-[25px]" />
            <input onChange={(e) => setSignUpData({ ...signUpData, name: e.target.value })} type="text" placeholder={t('Full Name')} className='w-[100%] bg-transparent outline-none px-[10px]' />
          </div>
          <div className="login-input focus-within:border-[#0000ffb7] mt-[20px] focus-within:border-[1px]">
            <img src={Emailicon} alt="EmailIcon" className="w-[25px]" />
            <input onChange={(e) => setSignUpData({ ...signUpData, email: e.target.value })} type="text" placeholder={t('Email')} className='w-[100%] bg-transparent outline-none px-[10px]' />
          </div>
          <div className="relative gap-[5px] login-input focus-within:border-[#0000ffb7] mt-[20px] focus-within:border-[1px]">
            <img src={Callicon} alt="Call Icon" className="w-[25px]" />
            <PhoneInput
              className="w-[100%]"
              ref={InputRef}
              international
              defaultCountry="IN"
              value={value}
              onChange={setValue}
              name="phone"
              style={{ outline: "none" }}
            />
            {!value && <h1 onClick={() => InputRef.current.focus()} className='absolute top-[10px] left-[90px] text-gray-500'>{t("Phone Number")}</h1>}
          </div>
          <div className="login-input focus-within:border-[#0000ffb7] mt-[20px] focus-within:border-[1px]">
            <img src={Lockicon} alt="userIcon" className="w-[25px]" />
            <input onChange={(e) => setSignUpData({ ...signUpData, password: e.target.value })} className="bg-transparent px-[10px] w-[100%] outline-none" type={passType} placeholder={t("Passowrd")} />
            <img onClick={() => passType === "text" ? setPassType("Password") : setPassType("text")} src={passType === "text" ? Eyeicon : Eyeslashicon} alt="LockIcon " className="w-[20px] cursor-pointer" />
          </div>

          <div className="login-input focus-within:border-[#0000ffb7] mt-[20px] focus-within:border-[1px]">
            <LuUsers className='text-[20px] text-[#383e4b]' />
            <input onChange={(e) => setSignUpData({ ...signUpData, referral: e.target.value })} type="text" placeholder={t('Referral Code (Optional)')} className='w-[100%] bg-transparent outline-none px-[10px]' />
          </div>

          <h1 className="mt-[10px] font-[600] text-[15px] text-gray-600">{t("By signing up, you agree to our")} <span className="text-[#0000ffb7]">{t("Terms of Service")}</span> {t("and")} <span className="text-[#0000ffb7]">{t("Privacy Policy.")}</span></h1>
          <button onClick={handelCheck} className='button'>{t("Sign Up")}</button>
          <h1 className='mt-[10px] text-center font-bold text-gray-600'>{t("Already have and account?")} <span onClick={() => { setIsLoginShow(true); setIsSignUpShow(false) }} className='text-[#0000ffb7] cursor-pointer'>{t("Sign In")}</span> </h1>
        </div>}
    </div>
  )
}

export default Signup;
/* jshint ignore:end */